import { QSpinner, QText } from '@qualio/ui-components';

const ActiveDueFilter = ({ value, dueMap }: { value: unknown; dueMap: Record<string, string> }) => {
  const id = value as string;
  const due = dueMap[id];
  if (due) {
    return <QText as="span">{due}</QText>;
  }
  return <QSpinner size="sm" />;
};

export default ActiveDueFilter;
